import { render, staticRenderFns } from "./ComponentCardHead.vue?vue&type=template&id=6e0c7421&scoped=true"
import script from "./ComponentCardHead.vue?vue&type=script&lang=js"
export * from "./ComponentCardHead.vue?vue&type=script&lang=js"
import style0 from "./ComponentCardHead.vue?vue&type=style&index=0&id=6e0c7421&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0c7421",
  null
  
)

export default component.exports